import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const serviceManagementRoutes = {
  name: 'list-service',
  path: 'service-management',
  component: () => import('./ServiceManagement.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
